const twelvedataRealTime = {
  price: '17.12000',
  timestamp: 1689326401577,
};

export default twelvedataRealTime;
